import React from 'react'
import BannerList from '../banner_components/banner_list'
import WebSidebar from '../../web_sidebar'
export default function
    () {
    return (
        <div>
            <div className='row'>

                <WebSidebar />


                <div className=''>


                    <BannerList />



                </div>
            </div>




        </div>
    )
}
